// @flow
import React from 'react';
import { isEmpty } from 'lodash';

import { COLORS } from 'Components/utils/color/colors';
import { isExclusiveCollection as isProductExclusiveCollection } from 'Components/utils/product/product.utils';

import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { ProductStrengths } from 'Components/widgets/product-strengths/ProductStrengths';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';

type Props = {|
  config: CMSContent,
  id: string,
  isExclusiveCollection: boolean,
  items: Array<{
    iconName: IconName,
    label: string,
    url?: string,
  }>,
  resort: Resort,
  title: string,
|};

export const ProductStrengthsLine = ({
  config: {
    common: { loadLess, loadMore },
  },
  id,
  items,
  isExclusiveCollection,
  resort: { comfort, type, isJoyview },
  title,
}: Props) => {
  if (isEmpty(items)) {
    return null;
  }

  const isEC = isProductExclusiveCollection(type, comfort) || isExclusiveCollection;

  const colorBlue = isEC ? COLORS.DEEP_BLUE : COLORS.BLUE;
  const color = isJoyview ? COLORS.WATER_GREEN : colorBlue;
  const coloredItems = items.map(item => ({ ...item, color }));

  return (
    <SiteContainer id={id} className="Line">
      <LineTitle color={color} isExclusiveCollection={isEC}>
        {title}
      </LineTitle>
      <ProductStrengths
        isExclusiveCollection={isEC}
        items={coloredItems}
        seeLessLabel={loadLess}
        seeMoreLabel={loadMore}
      />
    </SiteContainer>
  );
};
